import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumbersOnly]'
})
export class NumbersOnlyDirective {

  constructor(private el: ElementRef) { 
  }

  @HostListener('keydown', ['$event']) onKeyDown(event:KeyboardEvent){
   const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab']; 
    const isNumber = event.key.match(/^[0-9]$/); 

    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault(); 
    }
  }

}
